/**
 * Stub for ContentCreator when social components are excluded from build.
 * Keeps Content page compiling; full ContentCreator remains in codebase for later.
 */
import React from 'react';

export const ContentCreator: React.FC = () => (
  <div className="rounded-lg border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800 p-8 text-center">
    <p className="text-gray-500 dark:text-gray-400">Content creation — coming soon.</p>
  </div>
);
